import axios from '../axios';
import config from "../../../config";
import PartnerDetails from "../classes/PartnerDetails";
import Partner from "@/wl-core/api/classes/Partner";

export default {

    getPartners() {
        return axios.get('/partners').then(resp => {
            return resp.data.Data.map(p=> new Partner(p))
        });
    },
    getPartnerDetails() {
        return axios.get(config.host + '/partners/PartnerDetails')
            .then(resp => {
                return resp.data.Data.map(p => new PartnerDetails(p));
            })
    }
}
